import React from "react";
import { ListBuilder, PageLoader } from "@redriver/cinnamon";
import {
  withPermissions,
  PermissionCheck,
} from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { getSystemConfigs, updateSystemConfigs } from "./actions";
import { ConfigField } from "components/inputs";
const ListSystemConfig = ({ type, hasPermission, updatedDateTime }) => {
  let canEdit = hasPermission(Targets.SystemConfig, Actions.Edit);

  return (
    <PermissionCheck target={Targets.SystemConfig} action={Actions.View}>
      <ListBuilder
        loadAction={getSystemConfigs}
        loadParams={{ type, updatedDateTime }}
        renderList={(listData, state, listEvents) => (
          <div className="system-configs-list">
            {state.loading && <PageLoader />}
            {!state.loading &&
              Array.isArray(listData) &&
              listData.map((item) => (
                <ConfigField
                  key={`${item.key}_${updatedDateTime}`}
                  item={item}
                  type={type}
                  canEdit={canEdit}
                  onSubmitted={listEvents.onReset}
                  onCancel={listEvents.onReset}
                  updatedDateTime={updatedDateTime}
                  submitAction={updateSystemConfigs}
                />
              ))}
          </div>
        )}
      />
    </PermissionCheck>
  );
};

export default withPermissions(ListSystemConfig);
